module.exports = __webpack_public_path__ + "static/media/Background.8217fc2b.jpg";